import { AssetDetailPanel } from "@/features/assets/components/asset-registry/AssetDetailPanel";
import { useAssetById } from "@/features/assets/hooks/useAssetById";

interface AssetDetailPanelLoaderProps {
  assetId: string | null;
  onClose: () => void;
}

/**
 * Loads an asset by id and renders the shared `AssetDetailPanel` (the same
 * drawer used on the property Site Report list).
 */
export function AssetDetailPanelLoader({
  assetId,
  onClose,
}: AssetDetailPanelLoaderProps) {
  const { data: asset } = useAssetById(assetId);
  return (
    <AssetDetailPanel
      asset={asset ?? null}
      isOpen={Boolean(assetId)}
      onClose={onClose}
    />
  );
}
